module.exports = __webpack_public_path__ + "img/stage-img.5e0eff0f.png";